import {useLocalSearchParams} from "expo-router";
import {OfferDetailScreen} from "@/components/offers/OfferDetailScreen";

export default function OfferDetail() {
    const {orgId, offerId} = useLocalSearchParams<{orgId: string; offerId: string}>();
    return (
        <OfferDetailScreen orgId={orgId} offerId={offerId}/>
    );
}